import React, { useState } from 'react';
import { Eye, EyeOff, KeyRound, ArrowRight, Loader2 } from 'lucide-react';
import useAuthStore from '../stores/useAuthStore';
import { useTheme } from '../contexts/ThemeContext';
import { api } from '../lib/api';

// Troca de senha obrigatória (29/08/2026, pedido do usuário) — aparece no
// lugar do app inteiro quando operadorLogado.deveTrocarSenha vem true do
// login (conta nova, ou senha resetada/forçada pelo admin — sempre
// temporária). Mesmo padrão visual do Login.jsx, de propósito (mesma "tela
// de entrada", só com um propósito diferente). Ver RotaProtegida (App.jsx)
// pro bloqueio de fato.
export default function TrocarSenhaPrimeiroAcesso() {
    const { operadorLogado, limparDeveTrocarSenha, logout } = useAuthStore();
    const { theme } = useTheme();
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [mostrar, setMostrar] = useState(false);
    const [erro, setErro] = useState('');
    const [carregando, setCarregando] = useState(false);

    const handleSalvar = async (e) => {
        e.preventDefault();
        setErro('');
        if (novaSenha.length < 6) { setErro('Mínimo 6 caracteres.'); return; }
        if (novaSenha !== confirmar) { setErro('As senhas não coincidem.'); return; }
        setCarregando(true);
        try {
            await api.put('/api/auth/trocar-senha-primeiro-acesso', { senha: novaSenha });
            limparDeveTrocarSenha();
        } catch (err) {
            setErro(err.message || 'Erro ao trocar a senha.');
        } finally {
            setCarregando(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
            <div className="w-full max-w-[420px] relative z-10 animate-fade-in">
                <div className="text-center mb-10">
                    <img
                        src={theme === 'dark' ? `${import.meta.env.BASE_URL}logo-tecnofibras-negativo.png` : `${import.meta.env.BASE_URL}logo-tecnofibras.png`}
                        alt="Tecnofibras"
                        className="max-w-[210px] w-full mx-auto object-contain"
                    />
                    <h1 className="text-3xl font-bold text-anthracite-50 tracking-tight mt-6">Chão de Fábrica</h1>
                    <p className="text-[11px] font-bold text-anthracite-500 tracking-[0.2em] uppercase mt-2.5">Tecnofibras · Compósitos SMC e RTM/AT</p>
                </div>

                <div className="mes-card p-8">
                    <div className="mb-7">
                        <h2 className="text-lg font-semibold text-anthracite-100">Defina sua senha</h2>
                        <p className="text-[13px] text-anthracite-500 mt-1">
                            {operadorLogado?.nome ? `Olá, ${operadorLogado.nome}. ` : ''}
                            Por segurança, defina uma senha particular antes de continuar.
                        </p>
                    </div>

                    <form onSubmit={handleSalvar} className="space-y-5">
                        <div>
                            <label className="block text-[11px] font-bold text-anthracite-400 uppercase tracking-[0.15em] mb-2.5">Nova senha</label>
                            <div className="relative">
                                <KeyRound size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-anthracite-500" />
                                <input
                                    type={mostrar ? 'text' : 'password'}
                                    autoComplete="new-password"
                                    value={novaSenha}
                                    onChange={e => setNovaSenha(e.target.value)}
                                    placeholder="Mínimo 6 caracteres"
                                    className="mes-input pl-11 pr-11"
                                    required
                                />
                                <button type="button" onClick={() => setMostrar(!mostrar)} className="absolute right-4 top-1/2 -translate-y-1/2 text-anthracite-500 hover:text-anthracite-300 transition-colors">
                                    {mostrar ? <EyeOff size={16} /> : <Eye size={16} />}
                                </button>
                            </div>
                        </div>

                        <div>
                            <label className="block text-[11px] font-bold text-anthracite-400 uppercase tracking-[0.15em] mb-2.5">Confirmar senha</label>
                            <div className="relative">
                                <KeyRound size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-anthracite-500" />
                                <input
                                    type={mostrar ? 'text' : 'password'}
                                    autoComplete="new-password"
                                    value={confirmar}
                                    onChange={e => setConfirmar(e.target.value)}
                                    placeholder="Repita a senha"
                                    className="mes-input pl-11"
                                    required
                                />
                            </div>
                        </div>

                        {erro && (
                            <div className="rounded-2xl px-4 py-3 text-[12px] font-medium bg-red-500/10 border border-red-500/15 text-red-400">
                                {erro}
                            </div>
                        )}

                        <button type="submit" disabled={carregando} className="mes-btn-primary w-full py-3.5">
                            {carregando ? (<><Loader2 size={16} className="animate-spin" /> Salvando...</>) : (<>Confirmar <ArrowRight size={16} /></>)}
                        </button>

                        <div className="text-center">
                            <button type="button" onClick={logout} className="text-[12px] text-anthracite-500 hover:text-anthracite-300 transition-colors font-medium">
                                Sair
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
